export default __webpack_public_path__ + "static/media/central_andes_2_14.4e980572.JPG";